import {
  Clock3,
  FileCheck2,
  Fingerprint,
  GlobeLock,
  Image,
  ServerCog,
  Smartphone,
  type LucideIcon,
} from 'lucide-react';

export type TrustLayer = {
  id: string;
  icon: LucideIcon;
  titleKey: string;
  questionKey: string;
  textKey: string;
};

export const trustLayers: TrustLayer[] = [
  {
    id: 'photo',
    icon: Image,
    titleKey: 'trust.photo.title',
    questionKey: 'trust.photo.question',
    textKey: 'trust.photo.text',
  },
  {
    id: 'package',
    icon: FileCheck2,
    titleKey: 'trust.package.title',
    questionKey: 'trust.package.question',
    textKey: 'trust.package.text',
  },
  {
    id: 'signatures',
    icon: Fingerprint,
    titleKey: 'trust.signatures.title',
    questionKey: 'trust.signatures.question',
    textKey: 'trust.signatures.text',
  },
  {
    id: 'time',
    icon: Clock3,
    titleKey: 'trust.time.title',
    questionKey: 'trust.time.question',
    textKey: 'trust.time.text',
  },
  {
    id: 'server',
    icon: ServerCog,
    titleKey: 'trust.server.title',
    questionKey: 'trust.server.question',
    textKey: 'trust.server.text',
  },
  {
    id: 'app',
    icon: Smartphone,
    titleKey: 'trust.app.title',
    questionKey: 'trust.app.question',
    textKey: 'trust.app.text',
  },
  {
    id: 'public',
    icon: GlobeLock,
    titleKey: 'trust.public.title',
    questionKey: 'trust.public.question',
    textKey: 'trust.public.text',
  },
];
